export function parseJwtPayload(token) {
    if (!token || typeof token !== 'string') {
        return null;
    }

    const parts = token.split('.');
    if (parts.length < 2) {
        return null;
    }

    try {
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
        const json = atob(padded);

        return JSON.parse(json);
    } catch {
        return null;
    }
}

export function tokenRequiresOrgSelection(token) {
    return parseJwtPayload(token)?.requires_org_selection === true;
}